import React, { useCallback, useMemo } from "react";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";

interface AddCustomBodyComponentProps {
    section: {
        id: number;
        bodyCopy?: string;
    };
    onChange: (id: number, updatedData: Partial<any>) => void;
    onClose: () => void;
}


const AddCustomBodyComponent: React.FC<AddCustomBodyComponentProps> = ({
                                                                           section,
                                                                           onChange,
                                                                           onClose,
                                                                       }) => {
    const ReactQuill = require("react-quill");

    console.log(section.bodyCopy)
    const modules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link", "image"],
                ["clean"],
            ],
            keyboard: {
                bindings: {
                    customEnter: {
                        key: 13, // Enter key
                        handler: function (this: any, range: any, context: any) {
                            const quill: Quill = this.quill;

                            const [line, offset] = quill.getLine(range.index);
                            const textBefore = line.domNode.textContent
                                .slice(0, offset)
                                .trim();
                            const textAfter = line.domNode.textContent
                                .slice(offset)
                                .trim();

                            // If current line is empty or already blank -> create paragraph break
                            if (!textBefore && !textAfter) {
                                quill.insertText(range.index, "\n\n");
                            } else {
                                // Otherwise, just single line break
                                quill.insertText(range.index, "\n");
                            }

                            // 👇 Replace this:
                            // quill.setSelection(range.index + 1, Quill.sources.SILENT);
                            // 👇 With this:
                            quill.setSelection(range.index + 1, "silent");

                            return false;
                        },
                    },
                },
            },

        }),
        []
    );

    const cleanBody = useMemo(() => {
        if (!section.bodyCopy) return "";
        return section.bodyCopy
            .replace(/(&nbsp;)+/g, "&nbsp;")
            .replace(/\s{2,}/g, " ");
    }, [section.bodyCopy]);

    const handleBodyChange = useCallback(
        (value: string) => {
            const cleanedValue = value
                .replace(/(&nbsp;){2,}/g, "&nbsp;")
                .replace(/\s{2,}/g, " ");
            onChange(section.id, { bodyCopy: cleanedValue });
        },
        [section.id, onChange]
    );

    return (
        <div
            style={{
                padding: "10px",
                position: "relative",
                marginBottom: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
            }}
        >
            <button
                style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    border: "none",
                    background: "none",
                    color: "black",
                    cursor: "pointer",
                }}
                onClick={onClose}
            >
                X
            </button>

            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                Body Content
            </label>
            <ReactQuill
                value={cleanBody}
                onChange={handleBodyChange}
                modules={modules}
                theme="snow"
                style={{
                    width: "100%",
                    minHeight: "150px",
                    marginTop: "10px",
                }}
                placeholder="Enter body content here..."
            />
        </div>
    );
};

export default AddCustomBodyComponent;
